import { RootState } from "store/store";

export const selectAdmin = (state: RootState) => state.admin.current;

export const selectIsAuthed = (state: RootState) =>
  Boolean(state.admin.current);
